import type { ActionDrawerState, PrimaryCTA, SecondaryCTA } from '../../../core'
import { BottomActions, DEFAULT_BOTTOM_ACTIONS } from '../../../transactions/constants/Actions'
import { getDynamicCtaBasedOnTriggers } from '../util'

export const getBottomActionsByVariant = (
  actionDrawer: ActionDrawerState,
  primary_cta: PrimaryCTA | undefined,
  secondary_cta: SecondaryCTA | undefined,
): BottomActions[] => {
  const cta = getDynamicCtaBasedOnTriggers(actionDrawer, primary_cta, secondary_cta)

  switch (cta?.variant) {
    case 'fee_detected':
      return DEFAULT_BOTTOM_ACTIONS
    default:
      return [BottomActions.MerchantBudget, ...DEFAULT_BOTTOM_ACTIONS]
  }
}
